const KEY = "prospee_sector";

export const getSector = () => localStorage.getItem(KEY) || "all";

export const setSector = (v) => {
  localStorage.setItem(KEY, v || "all");
  window.dispatchEvent(new CustomEvent("sector-changed", { detail: v }));
};
